import React from 'react';

export default function EmptyState({ icon: Icon, title, children, action }) {
  return (
    <div className="rounded-lg border border-dashed border-gray-300 bg-white px-6 py-10 text-center">
      {Icon && <Icon className="mx-auto h-10 w-10 text-gray-400" aria-hidden="true" />}
      {title && <h3 className="mt-3 text-base font-medium text-gray-900">{title}</h3>}
      {children && <div className="mt-1 text-sm text-gray-600">{children}</div>}
      {action && <div className="mt-4 flex flex-wrap justify-center gap-2">{action}</div>}
    </div>
  );
}
